import React, { useState } from 'react';

import { Layout } from 'tea-component';
const { Content } = Layout;

import { FilterFixed, useFilterDataHook } from '../../components/FilterCommon';
import HeroEChart from './widgets/HeroEChart';
import CardLoading from '../../components/CardLoading';
import { connect, useIntl } from 'umi';
import { getHeroChartDate } from '../../services';
import HeroTable from './widgets/HeroTable';
import { dealwithCondHero } from './utils';
import '@/pages/opinion/assets/scss/pages/hero/index.scss';
import HeroPoint from '@op/operationLog/pages/hero';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import ContentBody from '../../components/ContentBody';
import { PAGE_NAME } from '@op/constants/page';

function Hero({ gameInfo, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: HeroPoint });
  const [languageType, setLanguageType] = useState<'zh' | 'origin' | 'en'>(
    'origin',
  );
  const [heroMap, setHeroMap] = useState<any>({});
  const { formatMessage } = useIntl();
  const { loading, filter, changeFilter, scrollBody, filterOptions } =
    useFilterDataHook({ pageName: 'Overview_Hero' });

  return (
    <Content className="dbo-hero" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.HERO}
        contentHeard={
          <Content.Header title={formatMessage({ id: PAGE_NAME.HERO })} />
        }
      >
        <FilterFixed
          filter={filterOptions}
          confirm={(value) => {
            changeFilter({ ...value, ...gameInfo });
          }}
          backCondOriginData={(data) => {
            setHeroMap(dealwithCondHero(data?.hok_hero || {}));
          }}
          scrollBody={scrollBody}
        ></FilterFixed>
        <CardLoading loading={loading}>
          <HeroEChart
            getServerDataFunc={getHeroChartDate}
            languageType={languageType}
            heroMap={heroMap}
            commonParams={filter}
          ></HeroEChart>
          <HeroTable
            languageType={languageType}
            setLanguageType={setLanguageType}
            commonParams={filter}
          ></HeroTable>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}
export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Hero);
